/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-02-25 17:10:01
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-19 13:47:56
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/customerReviews/commentFloor.tsx
 * @Description: default
 */
import "./commentList.scss";
import React from "react";
import CommentItem from "./commentItem";
import { PropsWithChildren } from "react";
import { EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";

interface Props extends PropsWithChildren<any> {
  skuId: string, // 商品id
  lists: any[], // 评论列表
  pageType?: string, // 页面类型
  onReviewBlockClick?: () => void, // 评论块点击
}

export default function ReviewsList({ pageType, onReviewBlockClick, lists = [], skuId }: Props) {
  return (
    <>
      <div className="review-list-wrapper">
        {
          lists?.map((item, key) => {
            const {
              commentId, // 评论id
              userImage, // 评论用户头像
              userNickName, // 评论用户昵称
              commentSku, // 评论商品
              commentDate, // 评论时间
              content, // 评论内容
              imageList = [], // 评论图片
              replyTreeCount, // 评论回复数量
              usefulVoteResult, // 评论是否有用
              usefulVoteCount, // 评论有用数量
              targetReplyId, // 评论回复目标id
              parentReplyId = 0, // 评论回复父级id
              userPin, // 评论用户pin
              replyList = [], // 评论回复列表
              anonymousFlag, // 评论是否匿名
              currentUserOperation, // 评论用户操作
              canDelete, // 评论是否可删除
            } = item
            const commentOpts = {
              commentId, // 评论id
              commentNum: replyTreeCount, // 评论回复数量
              currentIsUseful: usefulVoteResult, // 评论是否有用
              usefulNum: usefulVoteCount, // 评论有用数量
              anonymousFlag: anonymousFlag, // 评论是否匿名
              currentUserOperation: canDelete, // 评论用户操作
              skuId, // 评论商品id
            }
            const comment = {
              userImage, // 评论用户头像
              userNickName, // 评论用户昵称
              commentSku, // 评论商品
              commentDate, // 评论时间
              content, // 评论内容
              imageList, // 评论图片
              replyList, // 评论回复列表
              skuId // 评论商品id
            }
            const reportReqParams = {
              commentId, // 评论id
              targetReplyId, // 评论回复目标id
              parentReplyId, // 评论回复父级id
              toPin: userPin, // 评论回复目标pin
              toContent: content, // 评论回复目标内容
            }
            return <div
              className="reviews-item-block"
              key={key}
              onClick={onReviewBlockClick}
              exptag={"exp|" + EXPOSURE_RECORD.Productdetail_ReviewsFloor_SingleReview_Expo}
              data-exptag-config={dataExpTagConfig}
              data-exptag-json-param={JSON.stringify({
                mainskuid: skuId,
                commentId: String(commentId),
                index: key,
              })}
            >
              <CommentItem comment={comment} commentOpts={commentOpts} reportReqParams={reportReqParams} />
            </div>
          })
        }
      </div>
    </>
  )
}